export default __webpack_public_path__ + "media/images/users/user-mark-johnson-370x370-df89b0115feba2fc15eec8f68fdb2cdc.jpg";